import { Component, OnInit, inject, input } from '@angular/core';
import { ConstantService } from 'src/app/services/common/constant.service';

import { KeysPipe } from '../pipes/filter.pipe';

@Component({
    selector: 'app-row-detail',
    templateUrl: './row-detail.component.html',
    styleUrls: ['./row-detail.component.scss'],
    imports: [
    KeysPipe
],
})
export class RowDetailComponent implements OnInit {
  constantService = inject(ConstantService);

  readonly activity = input(undefined);

  ngOnInit(): void {}

  isObject(val): boolean {
    return val != null && typeof val === 'object';
  }
}
